var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "flex" }, [
    _c("h3", { staticClass: "m-3 flex-row baseline" }, [
      _vm._v("\n        " + _vm._s(_vm.$l10n.__("Sellsy")) + "\n        "),
      _c(
        "span",
        { staticClass: "flex-right" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                disabled: _vm.canEditSharing,
                placement: "bottom-end",
                content: _vm.$t.__(
                  "common.labels.no_permissions_to_perform_this_action"
                )
              }
            },
            [
              _c("CompassButton", {
                staticClass: "edit-button",
                attrs: {
                  label: _vm.$t.__(
                    "overview.tabs.SellsyInformationsSection.share"
                  ),
                  type: "tertiary",
                  disabled: !_vm.canEditSharing,
                  "data-upsell": "collaborative_sharing_suite",
                  "data-bot": _vm.databot["generalinfoedit2"]
                },
                on: { click: _vm.edit }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "px-3 bl-1" },
      [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "prelative tab-loader" },
              [_c("preloader", { attrs: { display: _vm.loading } })],
              1
            )
          : _c("div", [
              _c("h3", { staticClass: "mt-0" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Générales")))
              ]),
              _vm._v(" "),
              _c("ul", [
                _vm.infos.createdDate && _vm.infos.createdDate !== ""
                  ? _c(
                      "li",
                      {
                        staticClass: "data-block data-block-hover",
                        attrs: {
                          "data-bot": "overview__general-info--date-created"
                        }
                      },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Date de création")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "data-value" }, [
                          _c("span", [_vm._v(_vm._s(_vm.infos.createdDate))])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.infos.transformDate && _vm.infos.transformDate !== ""
                  ? _c(
                      "li",
                      {
                        staticClass: "data-block data-block-hover",
                        attrs: {
                          "data-bot":
                            "overview__general-info--date-transformation"
                        }
                      },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__("Date de transformation en client")
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "data-value" }, [
                          _c("span", [_vm._v(_vm._s(_vm.infos.transformDate))])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.infos.updatedDate && _vm.infos.updatedDate !== ""
                  ? _c(
                      "li",
                      {
                        staticClass: "data-block data-block-hover",
                        attrs: {
                          "data-bot": "overview__general-info--date-last-update"
                        }
                      },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__("Date de dernière mise à jour")
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "data-value" }, [
                          _c("span", [_vm._v(_vm._s(_vm.infos.updatedDate))])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.infos.owner && Object.keys(_vm.infos.owner).length > 0
                  ? _c(
                      "li",
                      {
                        staticClass: "data-block data-block-hover",
                        attrs: { "data-bot": "overview__general-info--owner" }
                      },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Propriétaire Sellsy")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "data-value editable-user" },
                          [
                            !_vm.isThird
                              ? _c("avatar-inline", {
                                  attrs: {
                                    data: _vm.infos.owner,
                                    size: "small"
                                  }
                                })
                              : _c("EditSingleUser", {
                                  attrs: {
                                    data: _vm.infos.owner,
                                    canEdit: _vm.canEditSharing,
                                    loading: _vm.updatingOwner
                                  },
                                  on: { update: _vm.handleOwnerUpdate }
                                })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.infos.sharedWithStaffs &&
                _vm.infos.sharedWithStaffs.length > 0
                  ? _c(
                      "li",
                      { staticClass: "data-block data-block-hover" },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Partagé avec")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.infos.sharedWithStaffs, function(
                          shared,
                          sharedIndex
                        ) {
                          return _c(
                            "span",
                            {
                              key: sharedIndex,
                              staticClass: "data-value mb-2"
                            },
                            [
                              _c("avatar-inline", {
                                attrs: { data: shared, size: "small" }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.infos.sharedWithGroups &&
                _vm.infos.sharedWithGroups.length > 0
                  ? _c(
                      "li",
                      { staticClass: "data-block data-block-hover" },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Groupe(s)")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.infos.sharedWithGroups, function(
                          group,
                          groupIndex
                        ) {
                          return _c(
                            "span",
                            { key: groupIndex, staticClass: "data-value" },
                            [_c("span", [_vm._v(_vm._s(group.name))])]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]),
        _vm._v(" "),
        _vm.canDisplayMassMailingConsent
          ? _c(
              "div",
              { staticClass: "data-block data-block-hover" },
              [
                _c("h3", { staticClass: "mt-0" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Marketing")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "data-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Inscription campagnes")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "flex-column",
                    attrs: {
                      disabled: !_vm.permissions.can_edit_campaign_subscription
                    },
                    on: { change: _vm.updateCampaign },
                    model: {
                      value: _vm.infos.campaigns,
                      callback: function($$v) {
                        _vm.$set(_vm.infos, "campaigns", $$v)
                      },
                      expression: "infos.campaigns"
                    }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          label: "sms",
                          "data-bot": "overview__general-info--marketing-sms"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("SMS")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          label: "phone",
                          "data-bot": "overview__general-info--marketing-phone"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Téléphonique")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          label: "email",
                          "data-bot": "overview__general-info--marketing-email"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Emails")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          label: "postmail",
                          "data-bot": "overview__general-info--marketing-mail"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Courrier")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          label: "custom",
                          "data-bot": "overview__general-info--marketing-custom"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Marketing personnalisé")) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.enableTags && !_vm.isThird
          ? _c("tags", {
              staticClass: "tags-150 mt-5",
              attrs: {
                linkedid: _vm.linkedid,
                linkedtype: _vm.linkedtype,
                options: _vm.tags,
                permissions: _vm.permissionsTag
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.thirdType !== "supplier" &&
        _vm.infos.score &&
        _vm.infos.score !== ""
          ? _c("div", [
              _c("h4", [_vm._v(_vm._s(_vm.$l10n.__("Score")))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pointer",
                  on: { click: _vm.openScoringHistory }
                },
                [
                  _c("span", { staticClass: "label mb-1 ellipsis" }, [
                    _vm._v(_vm._s(_vm.infos.score))
                  ])
                ]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }